import script from "./MilageInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./MilageInput.vue?vue&type=script&setup=true&lang=ts"

import "./MilageInput.vue?vue&type=style&index=0&id=1854157c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1854157c"]])

export default __exports__